var icon = require('vue-svgicon')
icon.register({
  'ks-icon-overflow': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M86.5 64a11.25 11.25 0 1 1 11.25 11.25A11.25 11.25 0 0 1 86.5 64m-33.75 0A11.25 11.25 0 1 1 64 75.25 11.25 11.25 0 0 1 52.75 64M19 64a11.25 11.25 0 1 1 11.25 11.25A11.25 11.25 0 0 1 19 64z"/>'
  }
})
